module.exports = __webpack_public_path__ + "static/media/rounded2.8b7cb76a.png";